import hamburger from './HamburgerMenu.svg'
import React from 'react';

const styles = {
  menuContainer: {
    flexDirection: 'column',
    display: 'flex',
    marginLeft: '25%',
    marginRight: '25%'
  },
  menuView: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 100,
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    display: 'flex'
  },
  menuIcon: {
    width: '80px',
    height: '80px',
    position: 'absolute',
    top: 0,
    right: 0,
    margin: 20
  },
}

function Menu() {
  return (
    <div style={styles.menuContainer}>
      <a href='/menu'>
        <img src={hamburger} style={styles.menuIcon} />
      </a>
      <div style={styles.menuView}>
        <a href='/'>
          <h2>Home</h2>
        </a>
        <a href='/about'>
          <h2>About</h2>
        </a>
        <a href='/voter-resources'>
          <h2>Voter Resources</h2>
        </a>
        <a href='/housing-justice'>
          <h2>Housing Justice</h2>
        </a>
        <a href='/postcard-gallery'>
          <h2>Postcard Gallery</h2>
        </a>
        <a href='/share-your-story'>
          <h2>Share Your Story</h2>
        </a>
        <a href='/social'>
          <h2>Social</h2>
        </a>
        <a href='/contact-us'>
          <h2>Contact Us</h2>
        </a>
      </div>
    </div>
  )
}

export default Menu;
